/**
 * Created by vaibhav on 31/3/18
 */
import React, {Component} from "react";
import config from "../../../meta/config";
import Link from 'gatsby-link'


const PartnerNavBar = ({title, meta_title, meta_desc, cover, slug, username}) => {
    let postURL = config.partnerformUrl + username;
    return (
        <nav className="navbar is-fixed-top" aria-label="main navigation">
            <div className="navbar-brand">
                <Link to="/" className="navbar-item has-text-weight-semibold is-size-4">
                    Common Energy
                </Link>
                <button className="button navbar-burger" data-target="navMenu">
                    <span/>
                    <span/>
                    <span/>
                </button>
            </div>
            <div className="navbar-menu" id="navMenu">
                <div className="navbar-start">
                </div>
                <div className="navbar-end">
                    <Link className="navbar-item" to="/pricing">
                        How It Works
                    </Link>
                    <Link className="navbar-item" to="/frequently-asked-questions">
                        FAQ
                    </Link>
                    <Link className="navbar-item" to="/blog">
                        Blog
                    </Link>
                    <div className="navbar-item">
                        <div className="field is-grouped">
                            <p className="control">
                                <a
                                    className="button is-primary"
                                    href={postURL}>
                                    Sign Up
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}    



export default PartnerNavBar;


// WEBPACK FOOTER //
// ./src/components/PartnerNavBar/index.js